module.exports = __webpack_public_path__ + "static/media/my-matches-example.bd75ba44.jpg";